var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMove = function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M.5 0H21v20.5H7A6.5 6.5 0 0 1 .5 14V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    fillRule: "nonzero",
    d: "M2 0h19v19H7a5 5 0 0 1-5-5V0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 12,
    r: 1.5,
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 7,
    r: 1.5,
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 12,
    r: 1.5,
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 7,
    r: 1.5,
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 12,
    r: 1.5,
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 7,
    r: 1.5,
    fill: "#545454"
  }))));
};

export default SvgMove;